import { motion } from "framer-motion";

export const KpiCard = ({ label, value, suffix, icon: Icon, accent = "#0071E3", delay = 0, testid }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay, type: "spring", stiffness: 260, damping: 22 }}
      className="bg-white rounded-2xl border border-black/5 shadow-[0_2px_10px_rgba(0,0,0,0.02)] p-5 transition-all duration-300 hover:shadow-[0_8px_30px_rgba(0,0,0,0.06)] hover:-translate-y-[2px]"
      data-testid={testid}
    >
      <div className="flex items-center justify-between mb-4">
        <p className="text-xs font-semibold text-[#86868B] uppercase tracking-wider">{label}</p>
        {Icon && (
          <div
            className="h-8 w-8 rounded-lg flex items-center justify-center"
            style={{ backgroundColor: `${accent}14` }}
          >
            <Icon className="h-4 w-4" strokeWidth={2} style={{ color: accent }} />
          </div>
        )}
      </div>
      <div className="flex items-baseline gap-1">
        <span className="font-heading text-4xl font-semibold tracking-tighter text-[#1D1D1F]">
          {value}
        </span>
        {suffix && <span className="text-lg font-medium text-[#86868B]">{suffix}</span>}
      </div>
    </motion.div>
  );
};

export default KpiCard;
